module.exports = __webpack_public_path__ + "img/LogoDashboard-11.68abefe7.svg";